import Grid from "@mui/material/Grid";
import MDBox from "../../../components/MDBox";
import ComplexStatisticsCard from "./Cards/StatisticsCards/ComplexStatisticsCard";
import { formatAmountWithRupeeSymbol } from "../../../common.js";

import InventoryIcon from '@mui/icons-material/Inventory';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import PaymentIcon from '@mui/icons-material/Payment';
import PaymentsIcon from '@mui/icons-material/Payments';

import { useTranslation } from "react-i18next";
function OverallReports(props) {
  const { t }     = useTranslation();

  let totalProductsCountAllTime   = props.overallReportObject.totalProductsCountAllTime ?? null;
  let totalSalesAllTime           = props.overallReportObject.totalSalesAllTime ?? null;
  let sellerTotalEarningAllTime   = props.overallReportObject.sellerTotalEarningAllTime ?? null;
  let adminTotalCommissionAllTime = props.overallReportObject.adminTotalCommissionAllTime ?? null;
  
  return (
    <Grid container spacing={3}>

      {totalProductsCountAllTime !== null ?         
      <Grid item xs={12} md={6} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            icon={<InventoryIcon />}
            title={t("Products")}
            count={totalProductsCountAllTime}     
            percentage={{
              color: "success",
              label: t("Overall Report"),
            }}                
          />
        </MDBox>
      </Grid>
      : <></>}

      {totalSalesAllTime !== null ? 
        <Grid item xs={12} md={6} lg={3}>
          <MDBox mb={1.5}>
            <ComplexStatisticsCard
              color="dark"
              icon={<AddShoppingCartIcon />}
              title={t("Total Sales")}
              count={formatAmountWithRupeeSymbol(totalSalesAllTime)} 
              percentage={{
                color: "success",
                label: t("Overall Report"),
              }}           
            />
          </MDBox>
        </Grid>
      : <></>}      

      {sellerTotalEarningAllTime !== null ? 
      <Grid item xs={12} md={6} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="success"
            icon= {<PaymentIcon />}
            title={t("Vendor Commission")}
            count={formatAmountWithRupeeSymbol(sellerTotalEarningAllTime)}        
            percentage={{
              color: "success",
              label: t("Overall Report"),
            }}             
          />
        </MDBox>
      </Grid>
      : <></>}

      {adminTotalCommissionAllTime !== null ? 
      <Grid item xs={12} md={6} lg={3}>
        <MDBox mb={1.5}>
          <ComplexStatisticsCard
            color="primary"
            icon={<PaymentsIcon />}
            title={t("Admin Commission")}
            count={formatAmountWithRupeeSymbol(adminTotalCommissionAllTime)}    
            percentage={{
              color: "success",
              label: t("Overall Report"),
            }}                 
          />
        </MDBox>
      </Grid>
      : <></>}
    </Grid>
  )
}

export default OverallReports;